import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    flex-direction: column-reverse;
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      flex-direction: row;
      min-height: 640px;
    }
  `}
`;

export const WrapperText = styled.div`
  ${({ theme, modalId }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: ${modalId === 'NO_CREDITS' ? 'center' : 'flex-start'};
    padding: 24px 20px;
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      padding: ${modalId === 'NO_CREDITS' ? '24px 45px' : '40px 32px 48px'};
      position: ${modalId === 'STUDIO_PRO_OFFER' ? 'absolute' : 'relative'};
      width: 517px;
    }
  `}
`;

export const TagPro = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.gradient.secondary};
    border-radius: 99px;
    display: inline-flex;
    color: ${theme.v2.colors.white.primary};
    font-size: 17.304px;
    font-weight: 500;
    gap: 5px;
    margin-bottom: 24px;
    padding: 7px 10px;
  `}
`;

export const Title = styled.div`
  ${({ theme, modalId }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: 500;
    line-height: 1.3;
    margin-bottom: ${modalId === 'NO_CREDITS' ? '16px' : '20px'};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const Text = styled.div`
  ${({ theme, modalId }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 1.5;
    margin-bottom: ${modalId === 'NO_CREDITS' ? '0' : '24px'};
  `}
`;

export const WrapperList = styled.ul`
  ${({ theme, modalId }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    list-style: none;
    margin: 0;
    padding: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-height: ${modalId === 'STUDIO_PRO_OFFER' ? 'calc((100vh - 65vw) - 339px)' : 'calc((100vh - 65vw) - 417px)'};
      overflow: hidden auto;
    }
  `}
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    align-items: flex-start;
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    font-size: ${theme.v2.font.sizes.xs};
    gap: 8px;
    line-height: 1.5;
  `}
`;

export const WrapperButton = styled.div`
  ${({ theme, modalId, isProPlan }) => css`
    display: flex;
    gap: ${modalId === 'NO_CREDITS' ? '24px' : '16px'};
    justify-content: ${modalId === 'STUDIO_PRO_OFFER' || isProPlan ? 'center' : 'flex-start'};
    margin-top: ${modalId === 'NO_CREDITS' ? '40px' : '25px'};
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column-reverse;
    }
  `}
`;

export const TextCancellation = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    line-height: 1.5;
    margin-top: 16px;
    text-align: center;
    width: 100%;
  `}
`;

export const WrapperImage = styled.div`
  ${({ theme, modalId }) => css`
    display: flex;
    overflow: hidden;

    img {
      max-width: 100%;
    }
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      border-radius: ${modalId === 'STUDIO_PRO_OFFER' ? '8px' : '0 8px 8px 0'};
      width: ${modalId === 'STUDIO_PRO_OFFER' ? '100%' : '443px'};
    }
  `}
`;

export const WrapperTextPro = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
`;

export const TextPro = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.gradient.secondary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.bold};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  `}
`;
